import React from 'react';
import { motion } from 'framer-motion';
export function Che2StructureScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-28">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-5xl" data-id="element-29">
        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-10" data-id="element-30">
          How this applies to Chronic Hand Eczema
        </h2>
        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200" data-id="element-31">
          <img src="https://cdn.magicpatterns.com/uploads/4g6Jcj2jtmmfszKnGoQAGg/Screenshot_2026-04-09_at_11.48.01.png" alt="CHE 2 Snak Structure Overview — showing engagement points through symptoms, sharing, body mapping, and emotional questions" className="w-full h-auto" data-id="element-32" />
        </div>
      </motion.div>
    </section>;
}